import { useStoredCart } from "./storage.mjs";
import { useMergeCartItems } from "./merge-cart.mjs";
import { resolveCartRouteOptions } from "./utils.mjs";
import { CART } from "../../const/cookies.mjs";
import { useChannels, topics } from "../channels.mjs";
import { useRoute, useCookie } from "#imports";
export function useSetupCart(cookies) {
  const { cartState } = useStoredCart();
  const { push, subscribe } = useChannels();
  const { mergeCartItems } = useMergeCartItems();
  const route = useRoute();
  if (cookies && cookies.cart && !cookies["is-secured"]) {
    (async function() {
      const { useGuestCart } = await import("./guest-cart.mjs");
      const { getCart: getGuestCart } = useGuestCart();
      cartState.value.cartId = cookies.cart;
      getGuestCart(resolveCartRouteOptions("guestCart", route.name));
    })();
  }
  subscribe(topics.auth.identify, async () => {
    if (process.client) {
      const { useCustomerCart } = await import("./customer-cart.mjs");
      const { getCart: getCustomerCart } = useCustomerCart();
      await getCustomerCart(
        resolveCartRouteOptions("customerCart", route.name)
      );
      push(topics.cart.fetchCustomerCart);
      const cartCookies = useCookie(CART);
      if (cartCookies.value) {
        await mergeCartItems(cartCookies.value);
        push(topics.cart.cartMerged);
      }
    }
  });
}
